import React from "react"
import PostCard from "./postCard"

export default function AllPosts({ posts }) {
  return (
    <div className="all-posts">
      {posts.map(({ node: post }) =>
        <PostCard
          key={post.id}
          post={post}
          aspectRatio={16/9} />
        )}
    </div>
  );
}
